import request from "@/utils/request";

  // 列表(主数据列表)
  export function loadStoreVisitReportListDataApi(data) {
    return request({
      url: "web/storeVisitReport/listData",
      method: "post",
      data
    });
  }
  // 导出
  export function loadStoreVisitReportExportDataApi(data) {
    return request({
      url: "web/storeVisitReport/exportData",
      method: "post",
      data
    });
  }
  // 导出图片zip
  export function loadStoreVisitReportExportPicZipApi(data) {
    return request({
      url: "web/storeVisitReport/exportPicZip",
      method: "post",
      data
    });
  }
  
  // 操作
  export function saveOrUpdateStoreVisitReportApi(data) {
    return request({
      url: "web/storeVisitReport/saveOrUpdate",
      method: "post",
      data
    });
  }
  
  // 查看
  export function initStoreVisitReportApi(data) {
    return request({
      url: "web/storeVisitReport/initStoreVisitReport",
      method: "post",
      data
    });
  }

  // 拜访统计列表(主数据列表)
  export function loadStoreVisitReportStatisticsListDataApi(data) {
    return request({
      url: "web/storeVisitReport/findListDataPageByStatistics",
      method: "post",
      data
    });
  }
  // 拜访统计导出
  export function loadStoreVisitReportStatisticsExportDataApi(data) {
    return request({
      url: "web/storeVisitReport/exportListDataPageByStatistics",
      method: "post",
      data
    });
  }
  // 拜访报表列表
  export function loadStoreVisitReportListSelectDataApi(data) {
    return request({
      url: "web/storeVisitReport/listSelectData",
      method: "post",
      data
    });
  }

  // 拜访物料明细列表(主数据列表)
  export function loadStoreVisitMaterialsDetailListDataApi(data) {
    return request({
      url: "web/storeVisitMaterialsDetail/listData",
      method: "post",
      data
    });
  }
  // 拜访物料明细导出
  export function loadStoreVisitMaterialsDetailExportDataApi(data) {
    return request({
      url: "web/storeVisitMaterialsDetail/exportData",
      method: "post",
      data
    });
  }
  // 根据报告id初始化物料明细
  export function findStoreVisitMaterialsDetailByReportIdApi(data) {
    return request({
      url: "web/storeVisitMaterialsDetail/findStoreVisitMaterialsDetailByReportId",
      method: "post",
      data
    });
  }
  // 根据零售户ID获取拜访物料明细
  export function findDetailInfoByStoreIdApi(data) {
    return request({
      url: "web/storeVisitMaterialsDetail/findDetailInfoByStoreId",
      method: "post",
      data
    });
  }
  // 优秀陈列列表(主数据列表)
  export function loadStoreVisitReportGoodKeepListDataApi(data) {
    return request({
      url: "web/storeVisitReport/listDataByGoodKeep",
      method: "post",
      data
    });
  }
  // 优秀陈列导出
  export function loadStoreVisitReportGoodKeepExportDataApi(data) {
    return request({
      url: "web/storeVisitReport/exportDataByGoodKeep",
      method: "post",
      data
    });
  }
  // 获取用户待提交报告数量
  export function findWaitSubmitReportCountByUserApi(data) {
    return request({
      url: "web/storeVisitReport/findWaitSubmitReportCountByUser",
      method: "post",
      data
    });
  }
  // 导出走访维护自查表
  export function loadStoreExportVisitSelfCheckTableApi(data) {
    return request({
      url: "web/storeVisitReport/exportVisitReportSelfCheck",
      method: "post",
      data
    });
  }